import { render } from "./MarketPlace.vue?vue&type=template&id=db59063a"
import script from "./MarketPlace.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketPlace.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/blogs/MarketPlace.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "db59063a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('db59063a', __exports__)) {
    api.reload('db59063a', __exports__)
  }
  
  module.hot.accept("./MarketPlace.vue?vue&type=template&id=db59063a", () => {
    api.rerender('db59063a', render)
  })

}


export default __exports__